import ahoy from 'ahoy.js';

ahoy.configure({
  trackVisits: false,
});
